import { Link } from 'react-router-dom';

// Static Privacy Policy page. Plain content — the global SiteFooter (App.js)
// still renders beneath it, so no footer here. This is a standard template and
// should be reviewed by counsel before it is relied upon.
const COMPANY = 'Bloom Products and Services, Inc.';
const EFFECTIVE_DATE = 'July 17, 2026';
const CONTACT_EMAIL = 'privacy@love-bloom.com';

const Privacy = () => (
    <div className="legal-page">
        <div className="legal-container">
            <Link to="/" className="legal-home">← Back to Bloom</Link>
            <h1 className="legal-title">Privacy Policy</h1>
            <p className="legal-meta">Last updated: {EFFECTIVE_DATE}</p>

            <p>
                This Privacy Policy explains how {COMPANY} (“Bloom,” “we,” “us,” or “our”)
                collects, uses, and shares information about you when you access or use the
                Bloom platform, websites, applications, and related services (together, the
                “Service”). By using the Service, you agree to the practices described here.
            </p>

            <h2>1. Information We Collect</h2>
            <p>
                We collect information you provide directly to us, such as your name, email
                address, and account credentials when you register; content you submit,
                including messages, images, and documents (for example receipts, appraisals,
                and insurance records); and information about the products and passports you
                create, hold, or transfer. We also collect certain information automatically
                when you use the Service, such as device and browser details, IP address, and
                usage and interaction data.
            </p>

            <h2>2. How We Use Information</h2>
            <p>
                We use the information we collect to provide, maintain, and improve the
                Service; to create and manage digital product passports and the records
                attached to them; to enable communication between owners and brands; to
                authenticate users and secure accounts; to respond to your requests; and to
                comply with legal obligations. We may use aggregated or de-identified data for
                analytics and product development.
            </p>

            <h2>3. How We Share Information</h2>
            <p>
                We share information as needed to operate the Service — for example, a
                product’s provenance and related records may be visible to the issuing brand,
                current owner, or prior owners according to their relationship to the product,
                as described in the Service. We may share information with service providers
                who process data on our behalf (such as hosting and infrastructure providers),
                and when required by law or to protect our rights. We do not sell your personal
                information.
            </p>

            <h2>4. Data Storage and Security</h2>
            <p>
                We use reasonable technical and organizational measures designed to protect
                your information. However, no method of transmission or storage is completely
                secure, and we cannot guarantee absolute security. Information may be stored and
                processed in the United States and other countries where we or our service
                providers operate.
            </p>

            <h2>5. Data Retention</h2>
            <p>
                We retain personal information for as long as your account is active or as
                needed to provide the Service, and thereafter as necessary to comply with our
                legal obligations, resolve disputes, and enforce our agreements. Because a
                product passport is designed to persist across owners, records associated with
                a passport may be retained for the life of that passport.
            </p>

            <h2>6. Your Rights and Choices</h2>
            <p>
                Depending on your location, you may have rights to access, correct, delete, or
                port your personal information, or to object to or restrict certain processing.
                You can update your account information at any time, and you may request changes
                by contacting us. We will respond to requests consistent with applicable law.
            </p>

            <h2>7. Cookies and Similar Technologies</h2>
            <p>
                We use cookies and similar technologies to keep you signed in, remember your
                preferences, and understand how the Service is used. You can control cookies
                through your browser settings, though some features may not function properly
                without them.
            </p>

            <h2>8. Third-Party Services</h2>
            <p>
                The Service may link to or integrate with third-party services that we do not
                control. Their handling of your information is governed by their own privacy
                policies, and we encourage you to review them.
            </p>

            <h2>9. Children’s Privacy</h2>
            <p>
                The Service is not directed to children under 18, and we do not knowingly
                collect personal information from children. If you believe a child has provided
                us with personal information, please contact us so we can delete it.
            </p>

            <h2>10. International Users</h2>
            <p>
                If you access the Service from outside the United States, you understand that
                your information may be transferred to, stored, and processed in the United
                States and other countries. Where required, we take steps to provide an
                appropriate level of protection for such transfers.
            </p>

            <h2>11. Changes to This Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. If we make material
                changes, we will update the “Last updated” date above and, where appropriate,
                provide additional notice. Your continued use of the Service after changes take
                effect constitutes acceptance of the revised policy.
            </p>

            <h2>12. Contact</h2>
            <p>
                Questions about this Privacy Policy may be sent to{' '}
                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>, {COMPANY}
            </p>
        </div>
    </div>
);

export default Privacy;
